export const BlogButtons: IBlogButton[] = [
	{
        buttonText: 'Все',
        buttonValue: 'all'
	},
	{
        buttonText: 'Догляд',
        buttonValue: 'care'
	},
	{
		buttonText: 'Новини',
	    buttonValue: 'news'
	},
	{
		buttonText: 'Успіхи',
	    buttonValue: 'success'
	},
    {
		buttonText: 'Звіт',
	    buttonValue: 'report'
	}
	
]